// @flow
import type { Validator } from 'redux-form/es/types'; // eslint-disable-line import/no-unresolved
import getFieldMeta from './getFieldMeta';

export default (field: string): Validator => {
    const meta = getFieldMeta(field);
    return meta.validationRule;
};
